<template>
  <div
    class="container"
    :style="{
      background:
        'url(' +
        require('../../assets/img/' + bei_ing) +
        ') no-repeat center center',
      'background-size': '100% 100%',
    }"
  >
    <!-- <div class="yindaoru" v-if="xue" @click="xues">
      <div class="qian">选择你要学习的课程</div>
      <video
        src="../../assets/xue.mp4"
        class="videp"
        :autoplay="autoplay"
        loop="true"
        id="xuess"
        muted="“muted”"
      ></video>
    </div> -->

    <dingbu></dingbu>
    <div class="home_content">
      <div class="bg_color">
        <div class="w">
          <div class="inform__box">
            <div class="box__top">
              <span class="shou__ye">首页</span>
              <span>
                <img class="img__o" src="../../assets/xiangyou (2).png" alt />
              </span>
              <span class="ton__zhi">学习系统</span>
            </div>
          </div>
        </div>
        <div class="box-contenthh" style="min-height: 455px">
          <div class="box-top-list" v-if="is_true">
            <div class="top-list-one">
              <div>{{ title.title_one }}：</div>
              <div class="one-li">
                <div
                  v-for="(item, index) in list"
                  :data-id="item.id"
                  :data-index="index"
                  :key="index"
                  @click="one"
                  :class="orderindex == index ? 'actives' : ''"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
            <div class="top-list-one">
              <div>{{ title.title_two }}：</div>
              <div class="one-li">
                <div
                  v-for="(item, index) in listtwo"
                  :key="index"
                  :data-id="item.id"
                  :data-index="index"
                  @click="two"
                  :class="orderindet == item.id ? 'actives' : ''"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="box-logh">
            <div
              class="box-tosgh"
              v-for="(item, index) in addki"
              :key="index"
              :plain="true"
              @click.stop="profile(item.id, item.need_pay)"
            >
              <div class="tos-img">
                <img class="shiping-lk" :src="item.image" alt />
              </div>
              <div class="tos-title">{{ item.examname }}</div>
              <div class="tos-timep">
                <div class="suoxud">所需课时：</div>
                <div class="keshi">{{ item.class_hour }}课时</div>
              </div>
              <div class="tos-timem">
                <div class="suoxud">已完成课时：</div>
                <div class="keshi">{{ item.finish_hour }}课时</div>
              </div>
              <div class="tos-timem">
                <div class="suoxud">截止日期：</div>
                <div class="keshi">{{ item.expirationtime }}</div>
              </div>
            </div>
          </div>

          <div class="fenye">
            <el-pagination
              background
              layout="prev, pager, next,jumper"
              :total="total"
              :page-size="pageNum"
              @prev-click="prev"
              @next-click="next"
              @current-change="current"
            ></el-pagination>
          </div>
        </div>
        <dibu></dibu>
      </div>
    </div>
    <!-- 购买弹窗 -->
    <div class="buy__boex" v-if="is_buy == true"></div>
    <div class="buy_items" v-if="is_buy == true">
      <div class="bott__ts">
        <div class="buy__names">您未购买该课程是否前往购买</div>
        <div class="buy__buttons">
          <div class="jin_btn">
            <el-button class="gou__buy" @click.stop="closeBuybox"
              >暂不购买</el-button
            >
          </div>
          <div class="jin_btn">
            <el-button class="gou__buy buy_styles" @click.stop="leaveForBuy"
              >前往购买</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <daohan></daohan>
  </div>
</template>

<script>
import daohan from "../daohan";
import dibu from "../dibu";
import dingbu from "../dingbu";
export default {
  components: {
    daohan,
    dibu,
    dingbu,
  },
  data() {
    return {
      is_buy: false,
      it_buy: false,
      addki: [],
      page: 1,
      pageNum: 10,
      total: 1,
      title: [],
      list: [],
      orderindex: 0,
      orderindet: "",
      orderindek: "",
      id: '',
      listtwo: [],
      listthree: [],
      xue: false,
      autoplay: true,
      bei_ing: this.Public.bei_ing,
      is_true: true,
      npay: '',
    };
  },
  mounted() {
    // window.addEventListener("beforeunload", (e) => {
    //   this.autoplay = true
    // });

    // if (localStorage.getItem("token-qzb")) {
    //   if (sessionStorage.getItem("xue") == 1) {
    //     this.xue = true;
    //     document.documentElement.scrollTop = 150;
    //     document.body.style.overflow = "hidden";
    //     document.addEventListener("touchmove", { passive: false }); // 禁止页面滑动
    //   }
    // }
  },
  created() {
    this.$forceUpdate()
    if (this.$route.query.info && JSON.parse(this.$route.query.info)) {
      let query = JSON.parse(this.$route.query.info)
      // // console.log(query);
      if (query) {
        this.id = query.id
        this.is_true = query.is_true
      }
    }
    let token = localStorage.getItem('token-qzb')
    this.getstudy();
    this.getlists();
    this.gettitle();
    this.getkey();
  },
  methods: {
    // xues() {
    //   sessionStorage.setItem("xue", 2);
    //   this.xue = false;
    //   document.body.style.overflow = ""; // 出现滚动条
    //   document.removeEventListener("touchmove", { passive: false });
    // },
    //标签切换
    one(e) {
      this.orderindex = e.target.dataset.index;
      this.id = e.target.dataset.id;
      let that = this;
      var url = "lists/get_list";
      let param = {
        id: that.id,
      };
      this.post(url, param)
        .then((res) => {
          that.listtwo = res.data;
          that.listthree = "";
          // console.log(res);
        })
        .catch((err) => {
          // console.log(err);
        });
      this.getstudy();
      this.orderindet = "";
    },
    two(e) {
      this.orderindet = e.target.dataset.id;
      this.id = e.target.dataset.id;
      let that = this;
      var url = "lists/get_list";
      let param = {
        id: that.id,
      };
      this.post(url, param)
        .then((res) => {
          that.listthree = res.data;
          // console.log(res);
        })
        .catch((err) => {
          // console.log(err);
        });
      this.getstudy();
    },
    therr(e) {
      this.orderindek = e.target.dataset.id;
      this.id = e.target.dataset.id;
      this.getstudy();
    },
    //分页
    //上一页
    prev() {
      this.page = this.page - 1;
      this.getstudy();
    },
    //下一页
    next() {
      this.page = this.page + 1;
      this.getstudy();
    },
    //当前页
    current(e) {
      this.page = e;
      this.getstudy();
    },
    //点击跳转到我的资料
    profile(id, npay) {
      //判断用户是否有权限
      let token = localStorage.getItem('token-qzb')
      if (token) {
        if (npay == 0) {   //  是否购买该课程  如果购买
          let that = this, url = "lists/study_detail", param = {
            id: id,
            pageNum: that.pageNum,
            page: that.page,
          };
          that.post(url, param)
            .then((res) => {
              localStorage.setItem("ordertodo", 0);
              if (res.code == 1) {
                sessionStorage.setItem("idto", id);
                this.$router.push({
                  path: "/profile",
                  query: { id: id },
                });
              }
            })
            .catch((err) => {
              // console.log(err);
            });
        } else {
          this.id = id
          this.npay = npay
          this.is_buy = true  // 展示购买弹窗
        }
      } else {
        this.$message("请先登录");
        this.$router.push({ path: '/login', query: { num: 1 } })
      }
    },
    //分类标题
    gettitle() {
      let that = this;
      var url = "lists/type_title";
      let param = {
        page: this.page,
        pageNum: this.pageNum,
      };
      this.post(url, param)
        .then((res) => {
          that.title = res.data;
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    //根据id获取分类列表
    getkey() {
      let that = this, url = "lists/get_list", param = {
        id: this.id || 1
      };
      this.post(url, param)
        .then((res) => {
          that.listtwo = res.data;
          that.listthree = "";
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    //分类标题
    getlists() {
      let that = this;
      var url = "lists/type_list";
      let param = {
        id: that.id
      };
      this.post(url, param)
        .then((res) => {
          that.list = res.data.one;
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    //学习系统接口
    getstudy() {
      let that = this;
      var url = "lists/study";
      let param = {
        page: that.page,
        pageNum: that.pageNum,
        type_id: that.id,
      };
      this.post(url, param)
        .then((res) => {
          this.addki = res.data.info;
          this.total = res.data.total_num;
          // console.log(res);
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    closeBuybox() {   // 暂不购买
      this.is_buy = false
    },
    leaveForBuy() {  // 前往购买
      this.is_buy = false
      this.$router.push({ path: '/submit', query: { id: this.id } })

    },
  },
};
</script>
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #198bf8 !important;
  color: #fff;
  border-radius: 50%;
}
.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  background-color: #ffffff;
  color: #06121e;
  min-width: 30px;
  border-radius: 2px;
}
</style>
<style scoped lang="less">
@import "../../css/learn.css";

.buy__boex {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  opacity: 0.6;
  background: #06121e;
}
.buy_items {
  width: 405px;
  background-color: #fff;
  position: fixed;
  top: 50%;
  left: 50%;
  border-radius: 8px;
  transform: translate(-50%, -50%);
  z-index: 10001;

  .bott__ts {
    width: 100%;
    padding: 34px;
    box-sizing: border-box;

    .buy__names {
      width: 100%;
      opacity: 1;
      font-size: 20px;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      font-weight: 500;
      text-align: center;
      color: #06121e;
      line-height: 26px;
    }

    .buy__buttons {
      width: 100%;
      display: flex;
      align-items: center;
      margin-top: 60px;

      .jin_btn {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;

        .gou__buy {
          width: 150px;
          height: 46px;
          opacity: 1;
          border: 1px solid #707070;
          border-radius: 23px;
          font-size: 20px;
          font-family: Source Han Sans CN, Source Han Sans CN-Regular;
          font-weight: 400;
          color: #06121e;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #fff !important;
        }

        .buy_styles {
          background-color: #3e8bff !important;
          color: #fff;
          border: 1px solid #3e8bff !important;
        }

        button {
          background: transparent;
        }
      }
    }
  }
}
</style>